import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { SidebarMenu } from '../components';
import mainLayoutClass from '../../../utils/mainLayoutClass';
import styles from '../../styles/views/layouts/MainLayout.module.scss';

const MainLayout = ({ children }) => {
  const location = useLocation();
  return (
    /*
    * TODO: remove next points after all pages will be moved to module.scss:
    * 1. `main-layout` className
    * 2. `mainLayoutClass(location)}-container` className
    * 3. data-theme
    */
    <div
      className={`main-layout ${styles.layout}
      ${mainLayoutClass(location)}-container`}
      data-theme="light"
    >
      <SidebarMenu />
      <div id="layout_content_wrapper" className={styles.contentWrapper}>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
};
MainLayout.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default MainLayout;
